var _title, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 123,
    height: 123,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email-round-line-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.482430718642206,0.040031390606600104 A61.46,61.46 0 1 1 18.04243071864221,18.0400313906066 A61.21,61.21 0 0 1 61.482430718642206,0.040031390606600104 zM33.33243071864221,38.6900313906066 h56.3 a3.6500000000000004,3.6500000000000004 0 0 1 3.64,3.64 V81.0400313906066 a3.5700000000000003,3.5700000000000003 0 0 1 -0.6300000000000006,2 a1.46,1.46 0 0 1 -0.3400000000000004,0.52 a1.51,1.51 0 0 1 -0.3400000000000004,0.24000000000000013 a3.7,3.7 0 0 1 -2.33,0.8500000000000005 H33.33243071864221 a3.63,3.63 0 0 1 -2.5700000000000003,-1.07 A3.67,3.67 0 0 1 29.692430718642207,81.0400313906066 V42.3300313906066 a3.6500000000000004,3.6500000000000004 0 0 1 3.64,-3.64 zm-0.8500000000000005,40.79 L52.21243071864221,59.7100313906066 L32.482430718642206,43.6200313906066 V79.4800313906066 zm21.9,-18 L34.04243071864221,81.8700313906066 H88.74243071864221 L69.3124307186422,61.4800313906066 L62.90243071864221,66.9400313906066 h0 a1.3900000000000001,1.3900000000000001 0 0 1 -1.79,0 l-6.73,-5.48 zm17,-1.81 l19,20 V43.4500313906066 l-19,16.22 zM34.28243071864221,41.4800313906066 L61.97243071864221,64.0400313906066 L88.4824307186422,41.4800313906066 zm68,-20.81 a57.7,57.7 0 1 0 16.91,40.81 a57.5,57.5 0 0 0 -16.91,-40.81 z",
    id: "svg_1",
    className: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8,
    strokeDasharray: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    d: "M4.4719085693359375,61.499996811151505 C4.4719085693359375,29.992765738325218 29.992765738325218,4.4719085693359375 61.499996811151505,4.4719085693359375 C93.00722788397779,4.4719085693359375 118.52808505296707,29.992765738325218 118.52808505296707,61.499996811151505 C118.52808505296707,93.00722788397779 93.00722788397779,118.52808505296707 61.499996811151505,118.52808505296707 C29.992765738325218,118.52808505296707 4.4719085693359375,93.00722788397779 4.4719085693359375,61.499996811151505 z",
    id: "svg_2",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFooter);
export default __webpack_public_path__ + "static/media/emailFooter.c78f34617a472c6d0a4f2bad7dc0221f.svg";
export { ForwardRef as ReactComponent };